import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LineItemCompletionMessage2zpi6q6jke1no as LineItemCompletionMessage } from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_lineItem36mnygy89sqfj as get_lineItem,
  get_created2khbw6a16fbfp as get_created,
} from '../../../../../crowpay-shared/com/crowpay/LineItemCompletionMessageFields.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { inside3oxyfk5qky4sm as inside } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import {
  RequestComplete2fbpvksxlxjbf as RequestComplete,
  ClientResponse3rdi8ggal48xs as ClientResponse,
  Accept733y3zepx42g as Accept,
  get_entries2nzs7h371ziik as get_entries,
} from '../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionResponse.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  shuffled357jrbcm2hlkc as shuffled,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  take3onnpy6q7ctcz as take,
  plus310ted5e4i90h as plus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { serializable2l0a6bc0gtxdw as serializable } from '../../../../../crowpay-shared/com/crowpay/completionResponse/serialization.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
} from '../components/nav/crowpay.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from './GenericDialog.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { requestFiles2wr6y980phloh as requestFiles } from '../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import {
  LocalFileyitm5ua4ch17 as LocalFile,
  uploadAllkv4v1vjrnv9u as uploadAll,
  FileDataw8niis0ucpno as FileData,
} from '../components/files/attachmentFilePreview.mjs';
import { modify2eca96i8s7hc2 as modify } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  Collection1k04j3hzsbod0 as Collection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
  bodyBold2czwdzwknab0k as bodyBold,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
} from '../theming/Titles.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { notificationBar4efejtg2792g as notificationBar } from '../theming/banners.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  get_scrollingHorizontally3ifk3kuuwhjjn as get_scrollingHorizontally,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  label287uhiq3m9m4z as label2,
  requiredLabel1u8ua88lul448 as requiredLabel,
} from '../components/label2.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText33v0vmsdeuehr as specCenteredText,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText_0,
  get_textButtonybbt8y3eu5hx as get_textButton,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  timesx4ey3un7ihw1 as times,
  Dimensions32ju1l7z4mh as Dimension,
  times2ukvaf6yk96p2 as times_0,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import {
  ApprovalToggles_getInstance35u0pxe4sacct as ApprovalToggles_getInstance,
  ApprovedSemantic_getInstance10vizqzbc90jx as ApprovedSemantic_getInstance,
  DeniedSemantic_getInstanceb7su0ait1it4 as DeniedSemantic_getInstance,
} from '../theming/approval.mjs';
import { RadioToggleButton6jdt9lqh3p8p as RadioToggleButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioToggleButton.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_atStart2tgdnaxgj04ln as get_atStart,
  get_atTopCenter1v6irntzl0tu6 as get_atTopCenter,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  equalTo2dio0vrcsd3je as equalTo,
  contains3hkd7li7hrfjb as contains,
} from '../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { Outlined_getInstancey8v9xg2p90sg as Outlined_getInstance } from '../theming/appTheme.mjs';
import {
  weightt34o7llf2uyq as weight,
  align1ejncrrer3meh as align,
  shownWhenxgf1ujy6rmvr as shownWhen,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { LineItemStateSemantic242xtb5m8w8mc as LineItemStateSemantic } from '../theming/states.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77 } from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  Indent_Tab_getInstance17jhdl82d14zt as Indent_Tab_getInstance,
  indented3383b46h9g40w as indented,
  space2ppi73m2qk1br as space,
} from '../components/space.mjs';
import { colored3y8uibz1hk46 as colored } from '../theming/colorManagement.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  CompactSemantic_getInstance287c07xso9hna as CompactSemantic_getInstance,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  Companion_instance2rgq1hlpwff0j as Companion_instance,
  Platform_Web_getInstanceu4ctcncq1n0 as Platform_Web_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { get_notNull33xpghyvur0tf as get_notNull } from '../../utils/utils.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from './GenericConfirmationDialog.mjs';
import { MinorAdjustmentsDialog1v336wr96b0sx as MinorAdjustmentsDialog } from './MinorAdjustmentsDialog.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ClientConcernSelectButtonx5iavwcao070 as ClientConcernSelectButton } from '../components/project/activity/concerns/tags.mjs';
import { ToggleButton22qnd3p3jsqqx as ToggleButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ToggleButton.commonHtml.mjs';
import { fileCarousely0kamh1gns47 as fileCarousel } from '../components/files/fileManager.mjs';
import { ReactiveMutableMapw66yu1ss5v6o as ReactiveMutableMap } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableMap.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import {
  AdjacentCardsSemantic_getInstance26qn2so7ofz0z as AdjacentCardsSemantic_getInstance,
  signOffHeader11hami6texki7 as signOffHeader,
} from '../components/signOffHeader.mjs';
import {
  exit12upnsqp8029y as exit,
  render1ekxzgt3v21h2 as render,
  DialogOrPageiidrs19hacf7 as DialogOrPage,
} from '../screens/common/DialogWithDialog.mjs';
import { get_titlelss9nf4gv6ut as get_title } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.efw_1.hf9($this.pii_1.jii_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, confirmed, $completion) {
  if (!confirmed)
    return Unit_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(LineItemCompletionMessage()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$1);
  var tmp_1 = get_lineItem(it);
  // Inline function 'kotlin.collections.map' call
  var this_1 = $this.qii_1.iii_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$3 = item.mf9_1;
    destination.v(tmp$ret$3);
  }
  var tmp_2 = inside(tmp_1, destination);
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_2 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_3 = serializerOrContextual(createKType(getKClass(LineItemCompletionMessage()), arrayOf([]), false));
  var tmp$ret$9 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$9);
  this_2.k4a(get_created(it_0));
  var tmp$ret$14 = this_2.m1r();
  var tmp_4 = await_0(session.efw_1.heo(new (Query())(tmp_2, tmp$ret$14)), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = tmp_4;
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = tmp0.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element = _iterator__ex2g4s_0.o1();
    var tmp$ret$15;
    $l$block: {
      var tmp_5 = element.d8w();
      var tmp0_elvis_lhs = tmp_5 instanceof RequestComplete() ? tmp_5 : null;
      var tmp_6;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$15 = null;
        break $l$block;
      } else {
        tmp_6 = tmp0_elvis_lhs;
      }
      var request = tmp_6;
      tmp$ret$15 = to(element.y6g_1, request);
    }
    var tmp0_safe_receiver = tmp$ret$15;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.v(tmp0_safe_receiver);
    }
  }
  var requests = toMap(destination_0);
  var filtered = $this.qii_1.lii_1 ? take(shuffled($this.qii_1.iii_1), $this.qii_1.iii_1.p1() / 2 | 0) : $this.qii_1.iii_1;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_1 = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = filtered.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var element_0 = _iterator__ex2g4s_1.o1();
    var tmp$ret$24;
    $l$block_0: {
      var review = $this.qii_1.nii_1.p3(element_0.mf9_1);
      var tmp5_project = element_0.lfy();
      var tmp6_lineItem = element_0.mf9_1;
      var tmp7_sender = session.gfv_1;
      var tmp1_elvis_lhs = review == null ? null : review.tii_1;
      var tmp8_message = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
      var tmp_7;
      if (review == null) {
        tmp_7 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_7 = serializable(new (ClientResponse())(review.sii_1));
      }
      var tmp3_elvis_lhs = tmp_7;
      var tmp_8;
      if (tmp3_elvis_lhs == null) {
        var tmp4_elvis_lhs = requests.p3(element_0.mf9_1);
        var tmp_9;
        if (tmp4_elvis_lhs == null) {
          tmp$ret$24 = null;
          break $l$block_0;
        } else {
          tmp_9 = tmp4_elvis_lhs;
        }
        tmp_8 = serializable(new (Accept())(tmp_9, session.wfw()));
      } else {
        tmp_8 = tmp3_elvis_lhs;
      }
      var tmp9_responseTypeSerializable = tmp_8;
      var message = new (LineItemCompletionMessage())(VOID, tmp5_project, tmp6_lineItem, tmp7_sender, true, tmp9_responseTypeSerializable, tmp8_message);
      var tmp_10 = session.vfw().hfg_1.qfm(message, $completion);
      if (tmp_10 === get_COROUTINE_SUSPENDED())
        tmp_10 = yield tmp_10;
      var tmp0_0 = tmp_10;
      // Inline function 'kotlin.also' call
      session.efw_1.dft(tmp0_0);
      tmp$ret$24 = tmp0_0;
    }
    var tmp0_safe_receiver_0 = tmp$ret$24;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_1.v(tmp0_safe_receiver_0);
    }
  }
  var sent = destination_1;
  if (!(sent.p1() === $this.qii_1.iii_1.p1())) {
    println('HERE');
    get_dialogStack().gbw(GenericDialog().dgh('Something Went Wrong', 'We got interrupted when submitting your responses, so not all of them were submitted correctly. Please make sure you have a strong WiFi connection and try again.', 'Okay'));
  } else {
    get_dialogStack().wgg();
  }
  return Unit_instance;
}
var ScopeSetReviewDialog$page$slambda$slambdaClass;
function ScopeSetReviewDialog$page$slambda$slambda() {
  if (ScopeSetReviewDialog$page$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.qii_1 = this$0;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ScopeSetReviewDialog$page$slambda$slambdaClass = $;
  }
  return ScopeSetReviewDialog$page$slambda$slambdaClass;
}
function ScopeSetReviewDialog$page$slambda$slambda_0(this$0) {
  var i = new (ScopeSetReviewDialog$page$slambda$slambda())(this$0);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function ScopeSetReviewDialog$page$slambda$lambda($this$MinorAdjustmentsDialog, it) {
  if (it) {
    get_dialogStack().wgg();
  } else {
    get_dialogStack().pgd();
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = requestFiles($this.vii_1.pc(), VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.map' call
  var this_0 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = new (LocalFile())(item);
    destination.v(tmp$ret$0);
  }
  var previews = destination;
  var tmp_0 = modify($this.wii_1, ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambda_0(previews), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$3 = tmp_1;
  var tmp_2 = uploadAll(previews, LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$ref_0(tmp$ret$3.vfw().hfg_1), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambdaClass;
function ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambda() {
  if (ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambdaClass === VOID) {
    class $ {
      constructor($previews) {
        this.xii_1 = $previews;
      }
      qge(before, $completion) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.xii_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp$ret$0 = new (FileData())(VOID, Signal().hak(''), item, item);
          destination.v(tmp$ret$0);
        }
        return plus(before, destination);
      }
      s2(p1, $completion) {
        return this.qge((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambdaClass = $;
  }
  return ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambdaClass;
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambda_0($previews) {
  var i = new (ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambda())($previews);
  var l = (before, $completion) => i.qge(before, $completion);
  l.$arity = 1;
  return l;
}
var LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$refClass;
function LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.yii_1 = p0;
      }
      uao($completion) {
        return this.yii_1.lfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.uao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = requestFiles($this.zii_1.pc(), VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.map' call
  var this_0 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = new (LocalFile())(item);
    destination.v(tmp$ret$0);
  }
  var previews = destination;
  var tmp_0 = modify($this.aij_1, ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambda_2(previews), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$3 = tmp_1;
  var tmp_2 = uploadAll(previews, LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$ref_2(tmp$ret$3.vfw().hfg_1), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambdaClass_0;
function ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambda_1() {
  if (ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($previews) {
        this.bij_1 = $previews;
      }
      qge(before, $completion) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.bij_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp$ret$0 = new (FileData())(VOID, Signal().hak(''), item, item);
          destination.v(tmp$ret$0);
        }
        return plus(before, destination);
      }
      s2(p1, $completion) {
        return this.qge((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambdaClass_0 = $;
  }
  return ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambdaClass_0;
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambda_2($previews) {
  var i = new (ScopeSetReviewDialog$radioOptionSelectLineItems$slambda$slambda_1())($previews);
  var l = (before, $completion) => i.qge(before, $completion);
  l.$arity = 1;
  return l;
}
var LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$refClass_0;
function LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$ref_1() {
  if (LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$refClass_0 === VOID) {
    class $ {
      constructor(p0) {
        this.cij_1 = p0;
      }
      uao($completion) {
        return this.cij_1.lfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$refClass_0 = $;
  }
  return LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$refClass_0;
}
function LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$ref_2(p0) {
  var i = new (LiveApi2$Api2LineItemCompletionMessageLive$uploadFileForRequest$ref_1())(p0);
  var l = ($completion) => i.uao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
var LineItemReviewClass;
function LineItemReview() {
  if (LineItemReviewClass === VOID) {
    class $ {
      constructor(itemId, concerns, message, files) {
        this.rii_1 = itemId;
        this.sii_1 = concerns;
        this.tii_1 = message;
        this.uii_1 = files;
      }
      dij(itemId, concerns, message, files) {
        return new (LineItemReview())(itemId, concerns, message, files);
      }
      eij(itemId, concerns, message, files, $super) {
        itemId = itemId === VOID ? this.rii_1 : itemId;
        concerns = concerns === VOID ? this.sii_1 : concerns;
        message = message === VOID ? this.tii_1 : message;
        files = files === VOID ? this.uii_1 : files;
        return $super === VOID ? this.dij(itemId, concerns, message, files) : $super.dij.call(this, itemId, concerns, message, files);
      }
      toString() {
        return 'LineItemReview(itemId=' + this.rii_1.toString() + ', concerns=' + toString(this.sii_1) + ', message=' + this.tii_1 + ', files=' + toString(this.uii_1) + ')';
      }
      hashCode() {
        var result = this.rii_1.hashCode();
        result = imul(result, 31) + hashCode(this.sii_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.tii_1) | 0;
        result = imul(result, 31) + hashCode(this.uii_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LineItemReview()))
          return false;
        if (!this.rii_1.equals(other.rii_1))
          return false;
        if (!equals(this.sii_1, other.sii_1))
          return false;
        if (!(this.tii_1 === other.tii_1))
          return false;
        if (!equals(this.uii_1, other.uii_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'LineItemReview');
    LineItemReviewClass = $;
  }
  return LineItemReviewClass;
}
function page($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  title(view, 'Review Request Sign-Off: ' + $this.kii_1.f99());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  view_0.lbb(notificationBar(view_0, AppColors_getInstance().lfz_1), body(view_0, "Items marked 'Not Ready' will have their funds held until the issue is resolved by the contractor."));
  view_0.lbb(notificationBar(view_0, AppColors_getInstance().kfz_1), body(view_0, 'Unchecked items will be approved and funds released, so make sure to mark every item you think is not ready. If no items are ready, consider filing a project-wide issue instead.'));
  view.hbb(p_0, view_0);
  label2(view, 'Select Approve or Not Ready for Each Work Item', VOID, ($this$label2) => $this$label2.lbb(sizeConstraints($this$label2, VOID, VOID, get_rem(20)), radioOptionSelectLineItems($this, $this$label2, $this.iii_1, $this.nii_1)));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  view_1.zbm(false);
  var tmp = get_primaryButton(view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Button())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  var tmp_0 = KMutableProperty0();
  var tmp_1 = Button$_get_enabled_$ref_61t7nx(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    var tmp$ret$4 = $this$reactiveScope.daj($this.oii_1);
    this_0.set(tmp$ret$4);
    return Unit_instance;
  });
  specCenteredText(view_2, ($this$specCenteredText) => $this$specCenteredText.daj($this.nii_1).i1() ? 'Approval All Work' : 'Submit');
  onClick(view_2, 'Submit', VOID, ScopeSetReviewDialog$page$slambda_0($this));
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp, view_2);
  var tmp_2 = get_secondaryButton(view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view_1.pc());
  var tmp0_elvis_lhs_3 = view_1.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
  view_1.gbb(p_3, view_3);
  specCenteredText_0(view_3, 'Adjustment');
  onClick(view_3, VOID, VOID, ScopeSetReviewDialog$page$slambda_2($this));
  view_1.hbb(p_3, view_3);
  view_1.lbb(tmp_2, view_3);
  var tmp_3 = get_textButton(view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Button())(view_1.pc());
  var tmp0_elvis_lhs_4 = view_1.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
  view_1.gbb(p_4, view_4);
  specCenteredText_0(view_4, 'Go Back');
  onClick(view_4, 'Exit', VOID, ScopeSetReviewDialog$page$slambda_4());
  view_1.hbb(p_4, view_4);
  view_1.lbb(tmp_3, view_4);
  view.hbb(p_1, view_1);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function radioOptionSelectLineItems($this, _this__u8e3s4, items, reviews) {
  var minChars = 35;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zbm(true);
    view_0.bb9(times(view_0.mba().jb0_1, 0.5));
    var review = reviews.xan(item.mf9_1);
    var tmp = ScopeSetReviewDialog$radioOptionSelectLineItems$lambda;
    var approved = review.vak(tmp, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_0(item));
    var tmp_0 = get_compact(view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.gbb(p_1, view_1);
    view_1.zbm(false);
    // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
    var breakpoint = get_AppDimensions().ig2_1;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowCollapsingToColumn())(view_1.pc(), listOf(new (Dimension())(breakpoint)));
    var tmp0_elvis_lhs_2 = view_1.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.gbb(p_2, view_2);
    view_2.bb9(times_0(get_AppDimensions().rg2_1, 2));
    var tmp_1 = view_2.jbb(ApprovalToggles_getInstance().abf(ApprovedSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RadioToggleButton())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.ebb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.gbb(p_3, view_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_3.pc());
    var tmp0_elvis_lhs_4 = view_3.ebb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
    view_3.gbb(p_4, view_4);
    view_4.zbm(false);
    var tmp_2 = get_centered(view_4);
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (IconView())(view_4.pc());
    var tmp0_elvis_lhs_5 = view_4.ebb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
    view_4.gbb(p_5, view_5);
    view_5.sbt(Companion_getInstance().xcf_1);
    view_5.gbu('Approve Line Item');
    view_4.hbb(p_5, view_5);
    view_4.lbb(tmp_2, view_5);
    view_4.lbb(get_centered(view_4), body(view_4, 'Approve'));
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (Space())(view_4.pc(), 0.1);
    var tmp0_elvis_lhs_6 = view_4.ebb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
    view_4.gbb(p_6, view_6);
    view_4.hbb(p_6, view_6);
    view_3.hbb(p_4, view_4);
    view_3.zah(view_3.bc9_1, approved);
    view_2.hbb(p_3, view_3);
    view_2.lbb(tmp_1, view_3);
    var tmp_3 = view_2.jbb(ApprovalToggles_getInstance().abf(DeniedSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (RadioToggleButton())(view_2.pc());
    var tmp0_elvis_lhs_7 = view_2.ebb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_2 : tmp0_elvis_lhs_7;
    view_2.gbb(p_7, view_7);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (RowOrCol())(view_7.pc());
    var tmp0_elvis_lhs_8 = view_7.ebb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
    view_7.gbb(p_8, view_8);
    view_8.zbm(false);
    var tmp_4 = get_centered(view_8);
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (IconView())(view_8.pc());
    var tmp0_elvis_lhs_9 = view_8.ebb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
    view_8.gbb(p_9, view_9);
    view_9.gbu('Line Item Not Ready');
    view_9.sbt(Companion_getInstance().vcf_1);
    view_8.hbb(p_9, view_9);
    view_8.lbb(tmp_4, view_9);
    view_8.lbb(get_centered(view_8), body(view_8, 'Not Ready'));
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_10 = new (Space())(view_8.pc(), 0.1);
    var tmp0_elvis_lhs_10 = view_8.ebb_1;
    var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
    view_8.gbb(p_10, view_10);
    view_8.hbb(p_10, view_10);
    view_7.hbb(p_8, view_8);
    view_7.zah(view_7.bc9_1, equalTo(approved, false));
    view_2.hbb(p_7, view_7);
    view_2.lbb(tmp_3, view_7);
    view_1.hbb(p_2, view_2);
    var tmp_5 = get_expanding(view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
    var breakpoint_0 = get_AppDimensions().ig2_1;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_11 = new (RowCollapsingToColumn())(view_1.pc(), listOf(new (Dimension())(breakpoint_0)));
    var tmp0_elvis_lhs_11 = view_1.ebb_1;
    var p_11 = tmp0_elvis_lhs_11 == null ? view_1 : tmp0_elvis_lhs_11;
    view_1.gbb(p_11, view_11);
    if (get_viewIsNarrow(view_11)) {
      dynamicTheme(view_11, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_1(approved));
    } else {
      view_11.lba(view_11.qb6_1.abf(Outlined_getInstance()));
    }
    view_11.lbb(view_11.kbb(weight(view_11, 2.25), align(view_11, Align_Start_getInstance(), Align_Center_getInstance())), bodyBold(view_11, item.nf9_1));
    var tmp_6 = view_11.kbb(view_11.kbb(weight(view_11, 1.0), align(view_11, Align_Start_getInstance(), Align_Center_getInstance())), view_11.jbb(LineItemStateSemantic(item.mfy())));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_12 = new (TextView())(view_11.pc());
    var tmp0_elvis_lhs_12 = view_11.ebb_1;
    var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
    view_11.gbb(p_12, view_12);
    view_12.lba(view_12.qb6_1.abf(BodySemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value = item.mfy().l9b_1;
    var tmp_7 = view_12.vb5_1;
    var tmp_8;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value) === 0) {
      tmp_8 = '\xA0';
    } else {
      tmp_8 = value;
    }
    tmp_7.hbu(tmp_8);
    view_12.dbs(Align_Center_getInstance());
    view_11.hbb(p_12, view_12);
    view_11.lbb(tmp_6, view_12);
    var tmp_9 = view_11.kbb(weight(view_11, 0.8), align(view_11, Align_Start_getInstance(), Align_Center_getInstance()));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_13 = new (TextView())(view_11.pc());
    var tmp0_elvis_lhs_13 = view_11.ebb_1;
    var p_13 = tmp0_elvis_lhs_13 == null ? view_11 : tmp0_elvis_lhs_13;
    view_11.gbb(p_13, view_13);
    view_13.lba(view_13.qb6_1.abf(BodySemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value_0 = MonetaryValue__toString_impl_xslc77(item.x91());
    var tmp_10 = view_13.vb5_1;
    var tmp_11;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value_0) === 0) {
      tmp_11 = '\xA0';
    } else {
      tmp_11 = value_0;
    }
    tmp_10.hbu(tmp_11);
    view_13.dbs(Align_Center_getInstance());
    view_11.hbb(p_13, view_13);
    view_11.lbb(tmp_9, view_13);
    view_1.hbb(p_11, view_11);
    view_1.lbb(tmp_5, view_11);
    view_0.hbb(p_1, view_1);
    view_0.lbb(tmp_0, view_1);
    var tmp_12 = shownWhen(view_0, VOID, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_2(approved));
    // Inline function 'com.crowpay.views.components.indentIfWideCol' call
    var indent = Indent_Tab_getInstance();
    var tmp_13;
    if (get_viewIsWide(view_0)) {
      // Inline function 'com.crowpay.views.components.indentedCol' call
      var tmp2 = indent.agr_1;
      // Inline function 'com.crowpay.views.components.indentedCol' call
      var afterSpace = indent.bgr_1;
      var tmp_14 = get_unpadded(view_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_14 = new (Frame())(view_0.pc());
      var tmp0_elvis_lhs_14 = view_0.ebb_1;
      var p_14 = tmp0_elvis_lhs_14 == null ? view_0 : tmp0_elvis_lhs_14;
      view_0.gbb(p_14, view_14);
      var tmp_15;
      var tmp_16 = null;
      if (!((tmp_16 == null ? null : new (Dimension())(tmp_16)) == null)) {
        tmp_15 = sizeConstraints(view_14, VOID, VOID, VOID, VOID, VOID, null);
      } else {
        tmp_15 = Companion_getInstance_0();
      }
      var tmp_17 = view_14.kbb(tmp_15, indented(view_14, tmp2, afterSpace));
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_15 = new (RowOrCol())(view_14.pc());
      var tmp0_elvis_lhs_15 = view_14.ebb_1;
      var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
      view_14.gbb(p_15, view_15);
      view_15.zbm(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_16 = new (Space())(view_15.pc(), 0.2);
      var tmp0_elvis_lhs_16 = view_15.ebb_1;
      var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
      view_15.gbb(p_16, view_16);
      view_15.hbb(p_16, view_16);
      requiredLabel(view_15, 'Concerns', ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_3(review));
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_17 = new (RowOrCol())(view_15.pc());
      var tmp0_elvis_lhs_17 = view_15.ebb_1;
      var p_17 = tmp0_elvis_lhs_17 == null ? view_15 : tmp0_elvis_lhs_17;
      view_15.gbb(p_17, view_17);
      view_17.zbm(true);
      view_17.bb9(get_AppDimensions().pg2_1);
      // Inline function 'com.crowpay.views.components.requiredField' call
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_18 = new (RowOrCol())(view_17.pc());
      var tmp0_elvis_lhs_18 = view_17.ebb_1;
      var p_18 = tmp0_elvis_lhs_18 == null ? view_17 : tmp0_elvis_lhs_18;
      view_17.gbb(p_18, view_18);
      view_18.zbm(true);
      view_18.bb9(get_AppDimensions().pg2_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_19 = new (RowOrCol())(view_18.pc());
      var tmp0_elvis_lhs_19 = view_18.ebb_1;
      var p_19 = tmp0_elvis_lhs_19 == null ? view_18 : tmp0_elvis_lhs_19;
      view_18.gbb(p_19, view_19);
      view_19.zbm(false);
      view_19.bb9(get_AppDimensions().rg2_1);
      view_19.lbb(get_centered(view_19), bodyBold(view_19, 'Reason'));
      view_19.lbb(colored(view_19, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_19, '*'));
      view_18.hbb(p_19, view_19);
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      var tmp_18 = view_18.jbb(FieldSemantic_getInstance());
      var tmp_19 = get_current(Companion_instance).equals(Platform_Web_getInstance()) ? sizeConstraints(view_18, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(5)) : Companion_getInstance_0();
      // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_20 = new (TextArea())(view_18.pc());
      var tmp0_elvis_lhs_20 = view_18.ebb_1;
      var p_20 = tmp0_elvis_lhs_20 == null ? view_18 : tmp0_elvis_lhs_20;
      view_18.gbb(p_20, view_20);
      var tmp_20 = get_notNull(review);
      var tmp_21 = ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_4;
      view_20.zah(view_20.scl_1, tmp_20.dak(tmp_21, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_5));
      view_20.vcl('Minimum ' + minChars + ' characters');
      view_18.hbb(p_20, view_20);
      var tmp$ret$61 = view_18.lbb(tmp_19, view_20);
      view_18.lbb(tmp_18, tmp$ret$61);
      view_17.hbb(p_18, view_18);
      var tmp_22 = get_atEnd(view_17);
      // Inline function 'com.crowpay.views.theming.smallBody' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_21 = new (TextView())(view_17.pc());
      var tmp0_elvis_lhs_21 = view_17.ebb_1;
      var p_21 = tmp0_elvis_lhs_21 == null ? view_17 : tmp0_elvis_lhs_21;
      view_17.gbb(p_21, view_21);
      view_21.lba(view_21.qb6_1.abf(SmallBodySemantic_getInstance()));
      var tmp_23 = KMutableProperty0();
      var tmp_24 = TextView$_get_content_$ref_4pzcwl(view_21);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('content', 0, tmp_23, tmp_24, TextView$_set_content_$ref_pketfb(view_21));
      reactiveScope(view_21, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_6(this_0, minChars, review));
      view_17.hbb(p_21, view_21);
      view_17.lbb(tmp_22, view_21);
      view_15.hbb(p_17, view_17);
      var tmp_25 = get_notNull(review);
      var tmp_26 = ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_7;
      var files = tmp_25.dak(tmp_26, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_8);
      view_15.dbn(get_px(0));
      var tmp_27 = shownWhen(view_15, VOID, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_9(files));
      view_15.lbb(tmp_27, label2(view_15, 'Attachments', VOID, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_10(files)));
      var tmp_28 = view_15.kbb(get_atStart(view_15), get_tertiaryButton(view_15));
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_22 = new (Button())(view_15.pc());
      var tmp0_elvis_lhs_22 = view_15.ebb_1;
      var p_22 = tmp0_elvis_lhs_22 == null ? view_15 : tmp0_elvis_lhs_22;
      view_15.gbb(p_22, view_22);
      specCenteredText_0(view_22, '+ Attachment');
      onClick(view_22, VOID, VOID, ScopeSetReviewDialog$radioOptionSelectLineItems$slambda_0(view_22, files));
      view_15.hbb(p_22, view_22);
      view_15.lbb(tmp_28, view_22);
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_23 = new (Space())(view_15.pc());
      var tmp0_elvis_lhs_23 = view_15.ebb_1;
      var p_23 = tmp0_elvis_lhs_23 == null ? view_15 : tmp0_elvis_lhs_23;
      view_15.gbb(p_23, view_23);
      view_15.hbb(p_23, view_23);
      view_14.hbb(p_15, view_15);
      view_14.lbb(tmp_17, view_15);
      view_0.hbb(p_14, view_14);
      tmp_13 = view_0.lbb(tmp_14, view_14);
    } else {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_24 = new (RowOrCol())(view_0.pc());
      var tmp0_elvis_lhs_24 = view_0.ebb_1;
      var p_24 = tmp0_elvis_lhs_24 == null ? view_0 : tmp0_elvis_lhs_24;
      view_0.gbb(p_24, view_24);
      view_24.zbm(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_25 = new (Space())(view_24.pc(), 0.2);
      var tmp0_elvis_lhs_25 = view_24.ebb_1;
      var p_25 = tmp0_elvis_lhs_25 == null ? view_24 : tmp0_elvis_lhs_25;
      view_24.gbb(p_25, view_25);
      view_24.hbb(p_25, view_25);
      requiredLabel(view_24, 'Concerns', ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_11(review));
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_26 = new (RowOrCol())(view_24.pc());
      var tmp0_elvis_lhs_26 = view_24.ebb_1;
      var p_26 = tmp0_elvis_lhs_26 == null ? view_24 : tmp0_elvis_lhs_26;
      view_24.gbb(p_26, view_26);
      view_26.zbm(true);
      view_26.bb9(get_AppDimensions().pg2_1);
      // Inline function 'com.crowpay.views.components.requiredField' call
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_27 = new (RowOrCol())(view_26.pc());
      var tmp0_elvis_lhs_27 = view_26.ebb_1;
      var p_27 = tmp0_elvis_lhs_27 == null ? view_26 : tmp0_elvis_lhs_27;
      view_26.gbb(p_27, view_27);
      view_27.zbm(true);
      view_27.bb9(get_AppDimensions().pg2_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_28 = new (RowOrCol())(view_27.pc());
      var tmp0_elvis_lhs_28 = view_27.ebb_1;
      var p_28 = tmp0_elvis_lhs_28 == null ? view_27 : tmp0_elvis_lhs_28;
      view_27.gbb(p_28, view_28);
      view_28.zbm(false);
      view_28.bb9(get_AppDimensions().rg2_1);
      view_28.lbb(get_centered(view_28), bodyBold(view_28, 'Reason'));
      view_28.lbb(colored(view_28, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_28, '*'));
      view_27.hbb(p_28, view_28);
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      var tmp_29 = view_27.jbb(FieldSemantic_getInstance());
      var tmp_30 = get_current(Companion_instance).equals(Platform_Web_getInstance()) ? sizeConstraints(view_27, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(5)) : Companion_getInstance_0();
      // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_29 = new (TextArea())(view_27.pc());
      var tmp0_elvis_lhs_29 = view_27.ebb_1;
      var p_29 = tmp0_elvis_lhs_29 == null ? view_27 : tmp0_elvis_lhs_29;
      view_27.gbb(p_29, view_29);
      var tmp_31 = get_notNull(review);
      var tmp_32 = ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_12;
      view_29.zah(view_29.scl_1, tmp_31.dak(tmp_32, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_13));
      view_29.vcl('Minimum ' + minChars + ' characters');
      view_27.hbb(p_29, view_29);
      var tmp$ret$103 = view_27.lbb(tmp_30, view_29);
      view_27.lbb(tmp_29, tmp$ret$103);
      view_26.hbb(p_27, view_27);
      var tmp_33 = get_atEnd(view_26);
      // Inline function 'com.crowpay.views.theming.smallBody' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_30 = new (TextView())(view_26.pc());
      var tmp0_elvis_lhs_30 = view_26.ebb_1;
      var p_30 = tmp0_elvis_lhs_30 == null ? view_26 : tmp0_elvis_lhs_30;
      view_26.gbb(p_30, view_30);
      view_30.lba(view_30.qb6_1.abf(SmallBodySemantic_getInstance()));
      var tmp_34 = KMutableProperty0();
      var tmp_35 = TextView$_get_content_$ref_4pzcwl_0(view_30);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_1 = getPropertyCallableRef('content', 0, tmp_34, tmp_35, TextView$_set_content_$ref_pketfb_0(view_30));
      reactiveScope(view_30, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_14(this_1, minChars, review));
      view_26.hbb(p_30, view_30);
      view_26.lbb(tmp_33, view_30);
      view_24.hbb(p_26, view_26);
      var tmp_36 = get_notNull(review);
      var tmp_37 = ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_15;
      var files_0 = tmp_36.dak(tmp_37, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_16);
      view_24.dbn(get_px(0));
      var tmp_38 = shownWhen(view_24, VOID, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_17(files_0));
      view_24.lbb(tmp_38, label2(view_24, 'Attachments', VOID, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_18(files_0)));
      var tmp_39 = view_24.kbb(get_atStart(view_24), get_tertiaryButton(view_24));
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_31 = new (Button())(view_24.pc());
      var tmp0_elvis_lhs_31 = view_24.ebb_1;
      var p_31 = tmp0_elvis_lhs_31 == null ? view_24 : tmp0_elvis_lhs_31;
      view_24.gbb(p_31, view_31);
      specCenteredText_0(view_31, '+ Attachment');
      onClick(view_31, VOID, VOID, ScopeSetReviewDialog$radioOptionSelectLineItems$slambda_2(view_31, files_0));
      view_24.hbb(p_31, view_31);
      view_24.lbb(tmp_39, view_31);
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_32 = new (Space())(view_24.pc());
      var tmp0_elvis_lhs_32 = view_24.ebb_1;
      var p_32 = tmp0_elvis_lhs_32 == null ? view_24 : tmp0_elvis_lhs_32;
      view_24.gbb(p_32, view_32);
      view_24.hbb(p_32, view_32);
      view_0.hbb(p_24, view_24);
      tmp_13 = view_24;
    }
    var tmp$ret$129 = tmp_13;
    view_0.lbb(tmp_12, tmp$ret$129);
    view.hbb(p_0, view_0);
  }
  _this__u8e3s4.hbb(p, view);
  return view;
}
var ScopeSetReviewDialog$renderAsDialog$slambdaClass;
function ScopeSetReviewDialog$renderAsDialog$slambda() {
  if (ScopeSetReviewDialog$renderAsDialog$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ScopeSetReviewDialog$renderAsDialog$slambdaClass = $;
  }
  return ScopeSetReviewDialog$renderAsDialog$slambdaClass;
}
function ScopeSetReviewDialog$renderAsDialog$slambda_0() {
  var i = new (ScopeSetReviewDialog$renderAsDialog$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ScopeSetReviewDialog$renderAsDialog$slambdaClass_0;
function ScopeSetReviewDialog$renderAsDialog$slambda_1() {
  if (ScopeSetReviewDialog$renderAsDialog$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.pii_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ScopeSetReviewDialog$renderAsDialog$slambdaClass_0 = $;
  }
  return ScopeSetReviewDialog$renderAsDialog$slambdaClass_0;
}
function ScopeSetReviewDialog$renderAsDialog$slambda_2(this$0) {
  var i = new (ScopeSetReviewDialog$renderAsDialog$slambda_1())(this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var ScopeSetReviewDialog$page$slambdaClass;
function ScopeSetReviewDialog$page$slambda() {
  if (ScopeSetReviewDialog$page$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.fij_1 = this$0;
      }
      uao($completion) {
        var rejected = this.fij_1.nii_1.p1();
        var approved = this.fij_1.iii_1.p1() - rejected | 0;
        var tmp = get_dialogStack();
        var tmp_0 = rejected === 0 ? 'Are you sure you want to approve and release payment for all ' + approved + ' items?' : approved === 0 ? 'Are you sure you want to mark all ' + rejected + ' items as not ready? You may want to consider filing a project-wide issue instead.' : 'Are you sure you want to mark ' + rejected + ' items as not ready? This will release payment for the other ' + approved + ' items.';
        tmp.zgd(new (GenericConfirmationDialog())('Submit Review', tmp_0, VOID, 'Submit', VOID, VOID, VOID, false, VOID, VOID, ScopeSetReviewDialog$page$slambda$slambda_0(this.fij_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ScopeSetReviewDialog$page$slambdaClass = $;
  }
  return ScopeSetReviewDialog$page$slambdaClass;
}
function ScopeSetReviewDialog$page$slambda_0(this$0) {
  var i = new (ScopeSetReviewDialog$page$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ScopeSetReviewDialog$page$slambdaClass_0;
function ScopeSetReviewDialog$page$slambda_1() {
  if (ScopeSetReviewDialog$page$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.gij_1 = this$0;
      }
      uao($completion) {
        var tmp = get_dialogStack();
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.gij_1.iii_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp$ret$0 = item.jf9_1;
          destination.v(tmp$ret$0);
        }
        var tmp_0 = destination;
        tmp.zgd(MinorAdjustmentsDialog().eht(tmp_0, this.gij_1.kii_1, ScopeSetReviewDialog$page$slambda$lambda));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ScopeSetReviewDialog$page$slambdaClass_0 = $;
  }
  return ScopeSetReviewDialog$page$slambdaClass_0;
}
function ScopeSetReviewDialog$page$slambda_2(this$0) {
  var i = new (ScopeSetReviewDialog$page$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ScopeSetReviewDialog$page$slambdaClass_1;
function ScopeSetReviewDialog$page$slambda_3() {
  if (ScopeSetReviewDialog$page$slambdaClass_1 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ScopeSetReviewDialog$page$slambdaClass_1 = $;
  }
  return ScopeSetReviewDialog$page$slambdaClass_1;
}
function ScopeSetReviewDialog$page$slambda_4() {
  var i = new (ScopeSetReviewDialog$page$slambda_3())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda(it) {
  return it == null;
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_0($item) {
  return (it) => it ? null : new (LineItemReview())($item.mf9_1, emptySet(), '', emptyList());
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_1($approved) {
  return ($this$dynamicTheme) => ($this$dynamicTheme.daj($approved) ? ApprovedSemantic_getInstance() : DeniedSemantic_getInstance()).abf(CardSemantic_getInstance());
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_2($approved) {
  return ($this$shownWhen) => !$this$shownWhen.daj($approved);
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda$lambda(it) {
  return it.sii_1;
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda$lambda_0(o, it) {
  return o.eij(VOID, it);
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_3($review) {
  return ($this$requiredLabel) => {
    var tmp = get_scrollingHorizontally($this$requiredLabel);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp$ret$0 = $this$requiredLabel.jbb(FieldSemantic_getInstance());
    var tmp_0 = $this$requiredLabel.kbb(tmp, tmp$ret$0);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$requiredLabel.pc());
    var tmp0_elvis_lhs = $this$requiredLabel.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$requiredLabel : tmp0_elvis_lhs;
    $this$requiredLabel.gbb(p, view);
    view.zbm(false);
    var tmp_1 = get_notNull($review);
    var tmp_2 = ScopeSetReviewDialog$radioOptionSelectLineItems$lambda$lambda;
    var concerns = tmp_1.dak(tmp_2, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda$lambda_0);
    var _iterator__ex2g4s = get_entries().m1();
    while (_iterator__ex2g4s.n1()) {
      var concernType = _iterator__ex2g4s.o1();
      // Inline function 'kotlin.let' call
      var it = ClientConcernSelectButton().agw(concernType);
      var tmp$ret$2 = get_viewIsNarrow(view) ? it.abf(CompactSemantic_getInstance()) : it;
      var tmp_3 = view.jbb(tmp$ret$2);
      // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (ToggleButton())(view.pc());
      var tmp0_elvis_lhs_0 = view.ebb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.gbb(p_0, view_0);
      if (get_viewIsNarrow(view_0))
        view_0.lbb(get_centered(view_0), body(view_0, concernType.e90()));
      else
        specCenteredText_0(view_0, concernType.e90());
      view_0.zah(view_0.pcq_1, contains(concerns, concernType));
      view.hbb(p_0, view_0);
      view.lbb(tmp_3, view_0);
    }
    $this$requiredLabel.hbb(p, view);
    $this$requiredLabel.lbb(tmp_0, view);
    return Unit_instance;
  };
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_4(it) {
  return it.tii_1;
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_5(o, it) {
  return o.eij(VOID, VOID, it);
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_6($this, $minChars, $review) {
  return ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.daj($review);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tii_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
    var remaining = $minChars - (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    var tmp$ret$0 = remaining <= 0 ? '' : '(' + remaining + ') more characters required';
    $this.set(tmp$ret$0);
    return Unit_instance;
  };
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_7(it) {
  return it.uii_1;
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_8(o, it) {
  return o.eij(VOID, VOID, VOID, it);
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_9($files) {
  return ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.daj($files).i1();
  };
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_10($files) {
  return ($this$label2) => fileCarousel($this$label2, $files, VOID, get_AppDimensions().tg2_1);
}
var ScopeSetReviewDialog$radioOptionSelectLineItems$slambdaClass;
function ScopeSetReviewDialog$radioOptionSelectLineItems$slambda() {
  if (ScopeSetReviewDialog$radioOptionSelectLineItems$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, $files) {
        this.vii_1 = $$this$button;
        this.wii_1 = $files;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ScopeSetReviewDialog$radioOptionSelectLineItems$slambdaClass = $;
  }
  return ScopeSetReviewDialog$radioOptionSelectLineItems$slambdaClass;
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$slambda_0($$this$button, $files) {
  var i = new (ScopeSetReviewDialog$radioOptionSelectLineItems$slambda())($$this$button, $files);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda$lambda_1(it) {
  return it.sii_1;
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda$lambda_2(o, it) {
  return o.eij(VOID, it);
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_11($review) {
  return ($this$requiredLabel) => {
    var tmp = get_scrollingHorizontally($this$requiredLabel);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp$ret$0 = $this$requiredLabel.jbb(FieldSemantic_getInstance());
    var tmp_0 = $this$requiredLabel.kbb(tmp, tmp$ret$0);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$requiredLabel.pc());
    var tmp0_elvis_lhs = $this$requiredLabel.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$requiredLabel : tmp0_elvis_lhs;
    $this$requiredLabel.gbb(p, view);
    view.zbm(false);
    var tmp_1 = get_notNull($review);
    var tmp_2 = ScopeSetReviewDialog$radioOptionSelectLineItems$lambda$lambda_1;
    var concerns = tmp_1.dak(tmp_2, ScopeSetReviewDialog$radioOptionSelectLineItems$lambda$lambda_2);
    var _iterator__ex2g4s = get_entries().m1();
    while (_iterator__ex2g4s.n1()) {
      var concernType = _iterator__ex2g4s.o1();
      // Inline function 'kotlin.let' call
      var it = ClientConcernSelectButton().agw(concernType);
      var tmp$ret$2 = get_viewIsNarrow(view) ? it.abf(CompactSemantic_getInstance()) : it;
      var tmp_3 = view.jbb(tmp$ret$2);
      // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (ToggleButton())(view.pc());
      var tmp0_elvis_lhs_0 = view.ebb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.gbb(p_0, view_0);
      if (get_viewIsNarrow(view_0))
        view_0.lbb(get_centered(view_0), body(view_0, concernType.e90()));
      else
        specCenteredText_0(view_0, concernType.e90());
      view_0.zah(view_0.pcq_1, contains(concerns, concernType));
      view.hbb(p_0, view_0);
      view.lbb(tmp_3, view_0);
    }
    $this$requiredLabel.hbb(p, view);
    $this$requiredLabel.lbb(tmp_0, view);
    return Unit_instance;
  };
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_12(it) {
  return it.tii_1;
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_13(o, it) {
  return o.eij(VOID, VOID, it);
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_14($this, $minChars, $review) {
  return ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.daj($review);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.tii_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
    var remaining = $minChars - (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    var tmp$ret$0 = remaining <= 0 ? '' : '(' + remaining + ') more characters required';
    $this.set(tmp$ret$0);
    return Unit_instance;
  };
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_15(it) {
  return it.uii_1;
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_16(o, it) {
  return o.eij(VOID, VOID, VOID, it);
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_17($files) {
  return ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.daj($files).i1();
  };
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$lambda_18($files) {
  return ($this$label2) => fileCarousel($this$label2, $files, VOID, get_AppDimensions().tg2_1);
}
var ScopeSetReviewDialog$radioOptionSelectLineItems$slambdaClass_0;
function ScopeSetReviewDialog$radioOptionSelectLineItems$slambda_1() {
  if (ScopeSetReviewDialog$radioOptionSelectLineItems$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$button, $files) {
        this.zii_1 = $$this$button;
        this.aij_1 = $files;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ScopeSetReviewDialog$radioOptionSelectLineItems$slambdaClass_0 = $;
  }
  return ScopeSetReviewDialog$radioOptionSelectLineItems$slambdaClass_0;
}
function ScopeSetReviewDialog$radioOptionSelectLineItems$slambda_2($$this$button, $files) {
  var i = new (ScopeSetReviewDialog$radioOptionSelectLineItems$slambda_1())($$this$button, $files);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ScopeSetReviewDialogClass;
function ScopeSetReviewDialog() {
  if (ScopeSetReviewDialogClass === VOID) {
    class $ {
      constructor(items, messages, scope, BREAK_FOR_TESTING) {
        BREAK_FOR_TESTING = BREAK_FOR_TESTING === VOID ? false : BREAK_FOR_TESTING;
        this.iii_1 = items;
        this.jii_1 = messages;
        this.kii_1 = scope;
        this.lii_1 = BREAK_FOR_TESTING;
        this.mii_1 = 35;
        this.nii_1 = ReactiveMutableMap().van();
        var tmp = this;
        tmp.oii_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0 = $this$remember.daj(this.nii_1).r3();
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.all' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp_0;
              if (element.tii_1.length >= this.mii_1) {
                // Inline function 'kotlin.collections.isNotEmpty' call
                tmp_0 = !element.sii_1.i1();
              } else {
                tmp_0 = false;
              }
              if (!tmp_0) {
                tmp$ret$0 = false;
                break $l$block_0;
              }
            }
            tmp$ret$0 = true;
          }
          return tmp$ret$0;
        });
      }
      ygs(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(ScopeSetReviewDialog$renderAsDialog$slambda_0());
        view.gba(get_AppDimensions().yg1_1);
        launch(view, VOID, VOID, ScopeSetReviewDialog$renderAsDialog$slambda_2(this));
        var tmp_0 = get_atTopCenter(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        var tmp0_vertical = get_rem(5);
        var tmp1_horizontal = get_px(0);
        view_0.jba(Edges().ed0(tmp1_horizontal, tmp0_vertical));
        view_0.eb9(true);
        var tmp_1 = view_0.kbb(view_0.kbb(get_centered(view_0), sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1)), view_0.jbb(AdjacentCardsSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        var $this$col = view_1;
        signOffHeader($this$col, 'SIGN-OFF REVIEW', 'Decisions in this section may release escrow funds.', () => {
          exit(this, $this$col);
          return Unit_instance;
        });
        $this$col.lbb($this$col.jbb(DialogSemantic_getInstance()), page(this, $this$col));
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_1, view_1);
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
      xgs(_this__u8e3s4) {
        var tmp = _this__u8e3s4.kbb(get_scrolling(_this__u8e3s4), _this__u8e3s4.jbb(AdjacentCardsSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        signOffHeader(view, 'SIGN-OFF REVIEW', 'Decisions in this section may release escrow funds.', null);
        space(view, get_rem(1));
        page(this, view);
        space(view, get_rem(1));
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).wd6 = render;
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'ScopeSetReviewDialog', VOID, VOID, [DialogOrPage()]);
    ScopeSetReviewDialogClass = $;
  }
  return ScopeSetReviewDialogClass;
}
//region block: exports
export {
  ScopeSetReviewDialog as ScopeSetReviewDialog3daipl4340b3e,
};
//endregion

//# sourceMappingURL=ScopeSetReviewDialog.mjs.map
